import React from 'react';

import {
    Chart,
    Series,
    CommonSeriesSettings,
    Legend,
    Tooltip,
    ArgumentAxis, Label, Format
} from 'devextreme-react/chart';
import { Size } from "devextreme-react/vector-map";
import { MyContext } from '../../../../context';


class StackedBarCase extends React.Component {

    static contextType = MyContext

    render() {

        let series;
        let data;

        switch (this.props.kpi) {
            case "OverallComplianceRate":
            case "CaseComplianceRate":
                {
                    series = [
                        {
                            valueField: "noHit",
                            name: this.context.getTranslation("compliance", "notCompliant")
                        },
                        {
                            valueField: "hit",
                            name: this.context.getTranslation("compliance", "compliant")
                        }
                    ]
                    break;
                }
            case "OverallEscalationRate":
            case "CaseEscalationRate": {
                series = [
                    {
                        valueField: "noHit",
                        name: this.context.getTranslation("compliance", "notEscalated")
                    },
                    {
                        valueField: "hit",
                        name: this.context.getTranslation("compliance", "escalated")
                    }
                ]
                break;
            }
        }

        data = this.props.data.map(d => {
            return (
                {
                    ...d,
                    args: this.props.type === "user" ?
                        this.props.persons.filter(p => p.userId === d.args)[0]?.name ?? ""
                        : d.args,
                }
            )
        })

        return (
            <Chart
                id="chart"
                ref={this.props.reference}
                dataSource={data}
                palette={this.props.palette}
            >
                <CommonSeriesSettings
                    ignoreEmptyPoints={true}
                    argumentField="args"
                    type="stackedBar"
                />

                {series.map(s =>
                    <Series
                        key={s.name}
                        valueField={s.valueField}
                        name={s.name}
                        stack={s.stack}
                    />
                )}

                <ArgumentAxis
                    allowDecimals={false}
                    axisDivisionFactor={60}
                >
                    <Label>
                        <Format type="decimal" />
                    </Label>
                </ArgumentAxis>
                <Legend
                    margin={0}
                    horizontalAlignment="center"
                    verticalAlignment="bot"
                />
                <Tooltip enabled={true} />

                <Size
                    height={this.props.size.height}
                    width={this.props.size.width}
                />
            </Chart>
        );
    }
}

export default StackedBarCase;
